import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';

const Redirect: FC = () => {
  return <Navigate to="/login" />;
};

export default Redirect;
